import {
  NearestFilter,
  RGBAFormat,
  RGBFormat,
  WebGLRenderTarget,
  LinearFilter,
  DepthTexture,
  UnsignedIntType,
  FloatType
} from "three";

export class BasicRenderTarget extends WebGLRenderTarget {
  constructor(width, height, hasAlpha=false) {
    super(width, height, {
      minFilter: LinearFilter,
      magFilter: LinearFilter,
      format: hasAlpha ? RGBAFormat : RGBFormat,
      stencilBuffer: false
    });
  }
}

export class EDLRenderTarget extends WebGLRenderTarget {
  constructor(width, height, isWebGL2) {
    super(width, height, {
      format: RGBAFormat,
      minFilter: NearestFilter,
      magFilter: NearestFilter,
      generateMipmaps: false,
      stencilBuffer: false,
      depthBuffer: true
    });

    this.depthTexture = new DepthTexture(width, height);
    this.depthTexture.type = isWebGL2 ? FloatType : UnsignedIntType;
  }
}

export class OpacityRenderTarget extends WebGLRenderTarget {
  constructor(width, height) {
    super(width, height, {
      format: RGBAFormat,
      minFilter: NearestFilter,
      magFilter: NearestFilter,
      stencilBuffer: false
    });
  }
}